import { useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"
import { useSelector } from "react-redux"

import api from "apis"

export const usePrefetchPages = () => {
  const queryClient = useQueryClient()
  const pagesToPrefetch = useSelector(
    (state) => state.sale.prefetch_pages || []
  )

  useEffect(() => {
    const prefetchPages = async () => {
      await Promise.all(
        ["homepage", ...pagesToPrefetch].map((url_path) =>
          queryClient.prefetchInfiniteQuery({
            queryFn: () =>
              api.fetch(
                `/api/v10/collections/${url_path}/load_react_collection?prefetch=1`
              ),
            queryKey: [url_path],
          })
        )
      )
    }

    prefetchPages()
  }, [])
}

export default usePrefetchPages
